/**
 * React Query cache roots for advisory / prime status fetches.
 * Separate keys per surface (incl. family counterparts) so switching routes
 * does not reuse a stale lifecycle for the wrong page.
 */
export const ELITE_PLANS_LANDING_STATUS_QUERY_KEY = 'ELITE_PLANS_LANDING_STATUS'
export const ELITE_PLANS_MEMBER_ELITE_STATUS_QUERY_KEY = 'ELITE_PLANS_MEMBER_ELITE_STATUS'
export const ELITE_PLANS_FAMILY_LANDING_STATUS_QUERY_KEY = 'ELITE_PLANS_FAMILY_LANDING_STATUS'
export const ELITE_PLANS_FAMILY_MEMBER_STATUS_QUERY_KEY = 'ELITE_PLANS_FAMILY_MEMBER_STATUS'
export const ELITE_LANDING_STATUS_QUERY_KEY = 'ELITE_LANDING_STATUS'
export const ELITE_DASHBOARD_STATUS_QUERY_KEY = 'ELITE_DASHBOARD_STATUS'
export const ELITE_FAMILY_LANDING_STATUS_QUERY_KEY = 'ELITE_FAMILY_LANDING_STATUS'
export const ELITE_FAMILY_DASHBOARD_STATUS_QUERY_KEY = 'ELITE_FAMILY_DASHBOARD_STATUS'
export const ELITE_PRIME_LANDING_STATUS_QUERY_KEY = 'ELITE_PRIME_LANDING_STATUS'
export const ELITE_PRIME_DASHBOARD_STATUS_QUERY_KEY = 'ELITE_PRIME_DASHBOARD_STATUS'
export const ELITE_PRIME_FAMILY_LANDING_STATUS_QUERY_KEY = 'ELITE_PRIME_FAMILY_LANDING_STATUS'
export const ELITE_PRIME_FAMILY_DASHBOARD_STATUS_QUERY_KEY = 'ELITE_PRIME_FAMILY_DASHBOARD_STATUS'
